import styles from './AvatarPicker.module.css';

export interface AvatarPickerProps {
  onSelect: (avatar: string) => void;
  selected?: string;
}

const AVATARS = [
  'Bioluminescent Ghost Fungus',
  'Blue Oyster',
  'Coral Fungus',
  'Fly Agaric',
  'Giant Puffball',
  'Golden Chanterelle',
  'Ink Cap',
  'Morel',
  'Shaggy Mane',
  'Turkey Tail',
] as const;

function getAvatarSrc(name: string): string {
  const file = name.toLowerCase().replace(/\s+/g, '-');
  return `/avatars/${file}.svg`;
}

export function AvatarPicker({ onSelect, selected }: AvatarPickerProps) {
  return (
    <div className={styles.container}>
      <div className={styles.grid} role="radiogroup" aria-label="Select a mushroom avatar">
        {AVATARS.map((name) => {
          const isSelected = selected === name;
          return (
            <button
              key={name}
              type="button"
              className={`${styles.avatarOption} ${isSelected ? styles.selected : ''}`}
              onClick={() => onSelect(name)}
              role="radio"
              aria-checked={isSelected}
              aria-label={name}
            >
              <div className={styles.imageWrapper}>
                <img
                  src={getAvatarSrc(name)}
                  alt={name}
                  className={styles.avatarImage}
                />
                {isSelected && (
                  <span className={styles.checkmark} aria-hidden="true">
                    ✓
                  </span>
                )}
              </div>
              <span className={styles.avatarName}>{name}</span>
            </button>
          );
        })}
      </div>
      {!selected && (
        <p className={styles.hint} role="alert">
          Please select an avatar
        </p>
      )}
    </div>
  );
}

export { AVATARS };
